var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherArmTopHighPressureHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 39",
    style: {
      enableBackground: "new 0 0 159 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B7FF;}\r\n\t.st1{fill:#00ADEE;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#FF001C;}\r\n\t.st4{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.82,32.56L76.82,32.56c-0.72,0-1.3,0.58-1.3,1.29l0,3.87c0,0.71,0.58,1.29,1.3,1.29h0 c0.72,0,1.3-0.58,1.3-1.29l0-3.87C78.12,33.13,77.54,32.56,76.82,32.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.83,17.09L76.83,17.09c-0.72,0-1.3,0.58-1.3,1.29l0,3.87c0,0.71,0.58,1.29,1.3,1.29h0 c0.72,0,1.3-0.58,1.3-1.29l0-3.87C78.13,17.67,77.55,17.09,76.83,17.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.83,24.82L76.83,24.82c-0.72,0-1.3,0.58-1.3,1.29l0,3.87c0,0.71,0.58,1.29,1.3,1.29h0 c0.72,0,1.3-0.58,1.3-1.29l0-3.87C78.12,25.4,77.54,24.82,76.83,24.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.84,9.36L76.84,9.36c-0.72,0-1.3,0.58-1.3,1.29l0,3.87c0,0.71,0.58,1.29,1.3,1.29h0 c0.72,0,1.3-0.58,1.3-1.29l0-3.87C78.13,9.94,77.55,9.36,76.84,9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.54,6.78c0,0.71,0.58,1.29,1.3,1.29h0c0.72,0,1.3-0.58,1.3-1.29l0-1.64h-2.6L75.54,6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.69,10.26c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49c-0.31,0.64-0.03,1.41,0.61,1.72 c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49C38.61,11.34,38.34,10.57,37.69,10.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.63,7.38c-0.31,0.64-0.04,1.41,0.61,1.72c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73 l1.61-3.34h-2.88L37.63,7.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.33,17.24c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49c-0.31,0.64-0.03,1.41,0.61,1.72 c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49C35.26,18.32,34.98,17.55,34.33,17.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.98,24.22c-0.65-0.31-1.42-0.03-1.73,0.61l-1.68,3.49c-0.31,0.64-0.03,1.41,0.61,1.72 c0.18,0.09,0.37,0.13,0.56,0.13c0.49,0,0.95-0.27,1.17-0.73l1.68-3.49C31.9,25.3,31.63,24.53,30.98,24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.19,24.39c-0.31-0.64-1.09-0.91-1.73-0.6s-0.92,1.08-0.6,1.72l1.7,3.48c0.22,0.46,0.69,0.73,1.17,0.73 c0.19,0,0.38-0.04,0.56-0.13c0.65-0.31,0.92-1.08,0.6-1.72L126.19,24.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121.11,13.95l-1.7-3.48c-0.31-0.64-1.09-0.91-1.73-0.6c-0.65,0.31-0.92,1.08-0.6,1.72l1.7,3.48 c0.22,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13C121.15,15.36,121.42,14.59,121.11,13.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.5,20.91l-1.7-3.48c-0.31-0.64-1.09-0.91-1.74-0.6c-0.65,0.31-0.92,1.08-0.6,1.72l1.7,3.48 c0.22,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13C124.54,22.32,124.81,21.55,124.5,20.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.38,8.11c0.22,0.46,0.69,0.73,1.17,0.73c0.19,0,0.38-0.04,0.56-0.13c0.65-0.31,0.92-1.08,0.6-1.72 l-0.89-1.84h-2.89L115.38,8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.79,5.96c-0.44,0.56-0.34,1.37,0.23,1.81c0.24,0.18,0.52,0.27,0.8,0.27c0.39,0,0.77-0.17,1.03-0.5l1.88-2.4 h-3.29L15.79,5.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.39,9.01L11,12.06c-0.44,0.56-0.34,1.37,0.23,1.81c0.24,0.18,0.52,0.27,0.8,0.27c0.39,0,0.77-0.17,1.03-0.5 l2.4-3.05c0.44-0.56,0.34-1.37-0.23-1.81C14.65,8.35,13.83,8.45,13.39,9.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.6,15.11l-1.94,2.47c-0.44,0.56-0.34,1.37,0.23,1.81c0.24,0.18,0.52,0.27,0.8,0.27 c0.39,0,0.77-0.17,1.03-0.5l1.94-2.47c0.44-0.56,0.34-1.37-0.23-1.81C9.85,14.44,9.04,14.54,8.6,15.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.5,13.38c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77c-0.16-0.69-0.85-1.13-1.55-0.97 c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1C97.31,13.41,97.41,13.4,97.5,13.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.23,20.92c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77c-0.16-0.69-0.85-1.13-1.55-0.97 c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1C99.04,20.95,99.13,20.94,99.23,20.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.49,5.87c0.09,0,0.19-0.01,0.29-0.03c0.39-0.09,0.69-0.35,0.86-0.69h-2.29C94.56,5.58,95,5.87,95.49,5.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.8,30.68c-0.16-0.69-0.85-1.13-1.55-0.97c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1 c0.09,0,0.19-0.01,0.29-0.03c0.7-0.16,1.14-0.85,0.98-1.54L102.8,30.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.95,28.46c0.7-0.16,1.14-0.85,0.98-1.54l-0.86-3.77c-0.16-0.69-0.85-1.13-1.55-0.97 c-0.7,0.16-1.14,0.85-0.98,1.54l0.86,3.77c0.14,0.6,0.67,1,1.27,1C100.76,28.49,100.86,28.48,100.95,28.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.64,7.14c0.26,0.33,0.64,0.5,1.03,0.5c0.28,0,0.56-0.09,0.79-0.27c0.57-0.44,0.67-1.25,0.23-1.81 l-0.32-0.41h-3.28L137.64,7.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.46,11.68l-2.39-3.06c-0.44-0.56-1.26-0.67-1.82-0.23c-0.57,0.44-0.67,1.24-0.23,1.81l2.39,3.06 c0.26,0.33,0.64,0.5,1.03,0.5c0.28,0,0.56-0.09,0.79-0.27C144.8,13.05,144.9,12.24,144.46,11.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.85,14.73c-0.44-0.56-1.26-0.67-1.82-0.23c-0.57,0.44-0.67,1.25-0.23,1.81l2.38,3.06 c0.26,0.33,0.64,0.5,1.03,0.5c0.28,0,0.56-0.09,0.79-0.27c0.57-0.44,0.67-1.25,0.23-1.81L146.85,14.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.11,14.58c-0.7-0.16-1.4,0.27-1.56,0.97l-0.88,3.77c-0.16,0.69,0.27,1.39,0.97,1.55 c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77C59.25,15.43,58.81,14.74,58.11,14.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.6,29.64c-0.7-0.16-1.4,0.27-1.56,0.96l-0.88,3.77c-0.16,0.69,0.27,1.39,0.97,1.55 c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77C55.74,30.49,55.3,29.8,54.6,29.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.36,22.11c-0.69-0.16-1.4,0.27-1.56,0.96l-0.88,3.77c-0.16,0.69,0.27,1.39,0.97,1.55 c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77C57.49,22.96,57.06,22.27,56.36,22.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.16,5.79c0.1,0.02,0.2,0.03,0.29,0.03c0.47,0,0.9-0.26,1.13-0.67h-2.25C59.5,5.46,59.79,5.7,60.16,5.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.87,7.04c-0.7-0.16-1.4,0.27-1.56,0.96l-0.88,3.77c-0.16,0.69,0.27,1.39,0.97,1.55 c0.1,0.02,0.2,0.03,0.29,0.03c0.59,0,1.13-0.4,1.26-1l0.88-3.77C61.01,7.89,60.57,7.2,59.87,7.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.26,31.42c-0.71-0.08-1.36,0.42-1.45,1.12l-0.47,3.84c-0.09,0.71,0.42,1.35,1.13,1.44 c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84C66.48,32.15,65.97,31.51,65.26,31.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.15,16.07c-0.7-0.08-1.36,0.42-1.45,1.12l-0.47,3.84c-0.09,0.71,0.42,1.35,1.13,1.44 c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84C68.37,16.8,67.87,16.16,67.15,16.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.1,8.4c-0.7-0.08-1.36,0.42-1.45,1.12l-0.47,3.84c-0.09,0.71,0.42,1.35,1.13,1.44 c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84C69.32,9.12,68.81,8.48,68.1,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.13,5.68c-0.09,0.71,0.42,1.35,1.13,1.44c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13 l0.1-0.85h-2.62L67.13,5.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.21,23.75c-0.7-0.08-1.36,0.42-1.45,1.12l-0.47,3.84c-0.09,0.71,0.42,1.35,1.13,1.44 c0.05,0.01,0.11,0.01,0.16,0.01c0.65,0,1.21-0.48,1.29-1.13l0.47-3.84C67.43,24.47,66.92,23.83,66.21,23.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.98,8.89c-0.49-0.52-1.32-0.54-1.84-0.06c-0.52,0.49-0.55,1.3-0.06,1.82l2.67,2.82 c0.26,0.27,0.6,0.41,0.95,0.41c0.32,0,0.64-0.12,0.89-0.35c0.52-0.49,0.55-1.3,0.06-1.82L155.98,8.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.41,7.84c0.26,0.27,0.6,0.41,0.95,0.41c0.32,0,0.64-0.12,0.89-0.35c0.52-0.49,0.55-1.3,0.06-1.82 l-0.88-0.93h-3.57L151.41,7.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.26,9.59c-0.61-0.38-1.41-0.19-1.79,0.41l-2.06,3.28c-0.38,0.6-0.19,1.4,0.41,1.78 c0.21,0.13,0.45,0.2,0.69,0.2c0.43,0,0.86-0.21,1.1-0.61l2.06-3.28C28.06,10.77,27.87,9.97,27.26,9.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.14,16.15c-0.61-0.38-1.41-0.19-1.79,0.41l-2.06,3.28c-0.38,0.6-0.19,1.4,0.41,1.78 c0.21,0.13,0.45,0.2,0.69,0.2c0.43,0,0.86-0.21,1.1-0.61l2.06-3.28C23.93,17.33,23.75,16.53,23.14,16.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.99,22.73c-0.61-0.37-1.42-0.16-1.8,0.44c-0.38,0.61-0.19,1.4,0.43,1.77c0.21,0.13,0.45,0.19,0.68,0.19 c0.44,0,0.86-0.22,1.11-0.61l0.02-0.04C19.8,23.88,19.6,23.1,18.99,22.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.53,6.73c-0.38,0.6-0.19,1.4,0.41,1.78c0.21,0.13,0.45,0.2,0.69,0.2c0.43,0,0.86-0.21,1.1-0.61l1.85-2.94 h-3.06L27.53,6.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.37,28.12c-0.24-0.67-0.98-1.03-1.65-0.79c-0.68,0.23-1.04,0.97-0.8,1.64l1.28,3.65 c0.19,0.53,0.69,0.87,1.23,0.87c0.14,0,0.29-0.02,0.43-0.07c0.68-0.23,1.04-0.97,0.8-1.64L114.37,28.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.17,11.5c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79 c-0.68,0.23-1.04,0.97-0.8,1.64l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87C106.88,11.57,107.03,11.55,107.17,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.73,18.8c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79 c-0.68,0.23-1.04,0.97-0.8,1.64l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87C109.44,18.88,109.59,18.85,109.73,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.29,26.11c0.68-0.23,1.04-0.97,0.8-1.64l-1.28-3.65c-0.24-0.67-0.98-1.03-1.65-0.79 c-0.68,0.23-1.04,0.97-0.8,1.64l1.28,3.65c0.19,0.53,0.69,0.87,1.23,0.87C112.01,26.18,112.15,26.16,112.29,26.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.82,6.04c0.25,0.24,0.58,0.36,0.9,0.36c0.34,0,0.68-0.13,0.93-0.39l0.84-0.86H5.42 C5.43,5.47,5.56,5.8,5.82,6.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.08,7L0.37,9.78c-0.5,0.51-0.49,1.33,0.03,1.82c0.25,0.24,0.58,0.36,0.9,0.36c0.34,0,0.68-0.13,0.93-0.39 l2.71-2.78c0.5-0.51,0.49-1.33-0.03-1.82C4.39,6.47,3.57,6.49,3.08,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.84,22.23c0.04,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.42l-0.41-3.85 c-0.08-0.71-0.72-1.22-1.43-1.15c-0.71,0.07-1.23,0.71-1.16,1.42l0.4,3.85C86.62,21.73,87.19,22.23,87.84,22.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.03,14.54c0.05,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.42l-0.4-3.85 c-0.08-0.71-0.71-1.22-1.43-1.15c-0.71,0.07-1.23,0.71-1.16,1.42l0.4,3.85C85.81,14.04,86.38,14.54,87.03,14.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.65,29.92c0.04,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.42l-0.4-3.85c-0.07-0.71-0.7-1.22-1.43-1.15 c-0.71,0.07-1.23,0.71-1.16,1.41l0.4,3.85C87.43,29.42,88,29.92,88.65,29.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.93,5.69c0.07,0.66,0.63,1.16,1.29,1.16c0.04,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.41l-0.03-0.27 h-2.61L84.93,5.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.92,31.19c-0.71,0.07-1.23,0.71-1.16,1.42l0.41,3.85c0.07,0.66,0.63,1.15,1.29,1.15 c0.04,0,0.09,0,0.14-0.01c0.71-0.07,1.23-0.71,1.16-1.42l-0.4-3.85C90.28,31.63,89.63,31.11,88.92,31.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.06,20.32c-0.37-0.61-1.17-0.8-1.79-0.43c-0.61,0.37-0.81,1.16-0.43,1.77l2.03,3.3 c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19c0.61-0.37,0.81-1.16,0.43-1.77L136.06,20.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.03,17.02l-2.03-3.3c-0.37-0.61-1.17-0.8-1.79-0.43c-0.61,0.37-0.81,1.16-0.43,1.77l2.03,3.3 c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19C134.21,18.43,134.4,17.63,134.03,17.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.97,10.43l-2.03-3.3c-0.37-0.61-1.17-0.8-1.79-0.43c-0.61,0.37-0.81,1.16-0.43,1.77l2.03,3.3 c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19C130.15,11.83,130.34,11.03,129.97,10.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.69,5.17c0.24,0.4,0.67,0.62,1.11,0.62c0.23,0,0.46-0.06,0.68-0.19c0.19-0.11,0.32-0.27,0.43-0.45h-2.23 L123.69,5.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.8,12.51c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64c-0.24,0.67,0.11,1.41,0.78,1.65 c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64C48.82,13.49,48.47,12.75,47.8,12.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.53,27.06c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64c-0.24,0.67,0.11,1.41,0.78,1.65 c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64C43.56,28.04,43.2,27.3,42.53,27.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.16,19.78c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64c-0.24,0.67,0.11,1.41,0.78,1.65 c0.15,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64C46.19,20.76,45.84,20.03,45.16,19.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.43,5.23c-0.68-0.24-1.42,0.11-1.66,0.78l-1.32,3.64c-0.24,0.67,0.11,1.41,0.78,1.65 c0.14,0.05,0.29,0.08,0.44,0.08c0.53,0,1.03-0.33,1.22-0.85l1.32-3.64C51.46,6.21,51.11,5.47,50.43,5.23z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.56,
    className: "st3",
    width: 155.55,
    height: 5.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherArmTopHighPressureHot);
export default __webpack_public_path__ + "static/media/washer_arm_top_high_pressure_hot.3fd1445f8881de54fd321dd94c7a241f.svg";
export { ForwardRef as ReactComponent };